// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>11</span>&nbsp;&nbsp;God is a righteous judge;&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;he is provoked all day long.<br> </p> </div></div>";
// Exports
module.exports = code;